import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { ContentProvider } from './content/ContentProvider'
import './design/styles/fonts.css'
import './design/styles/hr-tokens.css'
import './design/styles/hitrail-ds.css'
import './design/styles/hr-bridge.css'
import './design/styles/ngrs.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ContentProvider>
      <App />
    </ContentProvider>
  </React.StrictMode>,
)
